var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list a-card is-loading"},_vm._l((_vm.itemCount),function(num){return _c('loadingListItemPlaceholder',{key:num})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }